/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description default filters
 */

import { FilterRecordType } from '@zcode/nr/es/shared/bizos/filter'
import type { Filters } from '@zcode/state-type'
import deepFreeze from 'deep-freeze'
import type { O } from 'ts-toolbelt'

const getZumperDefaultFilters = (): Filters => {
  const filters: O.Writable<InstanceType<typeof FilterRecordType>> = new FilterRecordType({})

  // zumper specific default filters
  filters.longTerm = true
  filters.shortTerm = false
  filters.maxPrice = 10000
  return filters
}

const getZumperDefaultSTFilters = (): Filters => {
  const filters: O.Writable<InstanceType<typeof FilterRecordType>> = new FilterRecordType({})

  filters.longTerm = false
  filters.shortTerm = true
  return filters
}

export const DEFAULT_FILTERS = deepFreeze(getZumperDefaultFilters())
export const DEFAULT_ST_FILTERS = deepFreeze(getZumperDefaultSTFilters())
